"use client";

import React from "react";
import "./ToggleSwitch.css";

type ToggleColor = "primary" | "glory" | "success" | "danger" | "warning";
type ToggleVariant = "default" | "soft" | "glow";

interface ToggleSwitchProps {
  checked: boolean | undefined;
  onChange: (checked: boolean) => void;
  color?: ToggleColor;
  variant?: ToggleVariant;
  loading?: boolean;
  disabled?: boolean;
  title?: string;
}
 
const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  color = "primary",
  variant = "default",
  loading = false,
  disabled = false,
  title,
}) => {
  return (
    <label
      className={[
        "toggle-switch",
        "ios",
        variant,
        color,
        checked ? "checked" : "",
        loading ? "loading" : "",
        disabled ? "disabled" : "",
      ].join(" ")}
      title={title}
    >
      <input
        type="checkbox"
        checked={!!checked}
        disabled={disabled || loading}
        onChange={(e) => onChange(e.target.checked)}
      />

      <span className="track">
        <span className="knob">
          {loading && <span className="spinner" />}
        </span>
      </span>
    </label>
  );
};

export default ToggleSwitch;
